// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { RootState } from '~/utils/redux/store';
import {
  changeStatusQuote,
  cloneQuote,
  convertQuoteToOrder,
  createQuote,
  deleteQuote,
  getDetailQuote,
  getListQuote,
  sendMailQuote,
  updateQuote,
} from './quoteThunk';

export interface IQuoteState {
  isRefreshQuoteList: boolean;
  isRefreshQuoteDetail: boolean;
}

export const initialState: IQuoteState = {
  isRefreshQuoteList: false,
  isRefreshQuoteDetail: false,
};

const quoteSlice = createSlice({
  name: 'quote',
  initialState,
  reducers: {
    setRefreshQuoteList(state, action) {
      state.isRefreshQuoteList = action.payload;
    },
    setRefreshQuoteDetail(state, action) {
      state.isRefreshQuoteDetail = action.payload;
    },
  },
  extraReducers(builder) {
    // GET: Get list quote
    builder
      .addCase(getListQuote.pending, (_state) => {})
      .addCase(getListQuote.fulfilled, (_state) => {})
      .addCase(getListQuote.rejected, (_state) => {});

    // GET: Get detail quote
    builder
      .addCase(getDetailQuote.pending, (_state) => {})
      .addCase(getDetailQuote.fulfilled, (_state) => {})
      .addCase(getDetailQuote.rejected, (_state) => {});

    // POST: Create quote
    builder
      .addCase(createQuote.pending, (_state) => {})
      .addCase(createQuote.fulfilled, (_state) => {})
      .addCase(createQuote.rejected, (_state) => {});

    // POST: Update quote
    builder
      .addCase(updateQuote.pending, (_state) => {})
      .addCase(updateQuote.fulfilled, (_state) => {})
      .addCase(updateQuote.rejected, (_state) => {});

    // DELETE: Delete quote
    builder
      .addCase(deleteQuote.pending, (_state) => {})
      .addCase(deleteQuote.fulfilled, (_state) => {})
      .addCase(deleteQuote.rejected, (_state) => {});

    // POST: Convert quote to order
    builder
      .addCase(convertQuoteToOrder.pending, (_state) => {})
      .addCase(convertQuoteToOrder.fulfilled, (_state) => {})
      .addCase(convertQuoteToOrder.rejected, (_state) => {});

    // PUT: Change status quote
    builder
      .addCase(changeStatusQuote.pending, (_state) => {})
      .addCase(changeStatusQuote.fulfilled, (_state) => {})
      .addCase(changeStatusQuote.rejected, (_state) => {});

    // POST: Clone quote
    builder
      .addCase(cloneQuote.pending, (_state) => {})
      .addCase(cloneQuote.fulfilled, (_state) => {})
      .addCase(cloneQuote.rejected, (_state) => {});

    // PUT: Send mail quote
    builder
      .addCase(sendMailQuote.pending, () => {})
      .addCase(sendMailQuote.fulfilled, () => {})
      .addCase(sendMailQuote.rejected, () => {});
  },
});

// Action
export const quoteActions = quoteSlice.actions;

// Selectors
export const selectIsRefreshListQuote = (state: RootState) => state.quote.isRefreshQuoteList;
export const selectIsRefreshDetailQuote = (state: RootState) => state.quote.isRefreshQuoteDetail;

// Reducer
const quoteReducer = quoteSlice.reducer;
export default quoteReducer;
